(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminMeterDisplaySettingsController', AdminMeterDisplaySettingsController);

    function AdminMeterDisplaySettingsController(
        $controller,
        lodash,
        settingsCollection,
        recurrenceRulesService,
        elbSettings,
        $state,
        module,
        modulesService
    ) {
        const vm = this;
        const base = $controller('AdminDisplaySettingsController', {
            lodash: lodash,
            settingsCollection: settingsCollection,
            settingsFields: [
                'meter_force_stick_to_date',
                'meter_grace_period_week_before',
                'meter_grace_period_week_after',
                'meter_grace_period_month_before',
                'meter_grace_period_month_after',
                'meter_grace_period_year_before',
                'meter_grace_period_year_after',
                'meter_generate_week_day',
                'meter_generate_month_day',
                'meter_generate_year_day',
                'meter_generate_year_month'
            ],
            recurrenceRulesService: recurrenceRulesService,
            elbSettings: elbSettings,
            $state: $state,
            module: module,
            modulesService: modulesService
        });

        angular.extend(vm, base);
    }
})();
